import { Observable } from 'rxjs';
import {
  ApiClient,
  ChangeOrderHistoryItem,
  ChangeOrderInfo,
  ChangeOrderItem,
  ChangeOrderTaxLineRequest,
  CreateChangeOrderRequest,
} from '../sdk/sdk';
import {Injectable, inject} from '@angular/core';
import {ChangeOrderFormData} from '../components/change-order-modal/change-order-modal.component';
import {isValidDescopeChange} from '../utils/descope-change';

@Injectable({
  providedIn: 'root',
})
export class ChangeOrderService {
  private readonly sdk = inject(ApiClient);

  getHistory(jobId: string): Observable<ChangeOrderHistoryItem[]> {
    return this.sdk.getChangeOrderHistory(jobId);
  }

  createChangeOrder(formData: ChangeOrderFormData, idempotencyKey: string): Observable<ChangeOrderInfo[]> {
    const upsellItems = formData.upsellItems.map(i => new ChangeOrderItem({
      productId: i.productWithPricing.id,
      quantity: i.quantity,
      grossAmount: i.productWithPricing.listPrice * i.quantity,
      netAmount: i.netAmount,
    }));

    const descopeItems = formData.descopeItems
      .filter(i => isValidDescopeChange(i))
      .map(i => new ChangeOrderItem({
        productId: i.productWithPricing.id,
        quantity: i.quantity - i.originalQuantity,
        grossAmount: i.productWithPricing.listPrice * (i.quantity - i.originalQuantity),
        netAmount: i.netAmount - i.originalNetAmount,
      }));

    const taxes = formData.taxes
      .filter(t => t.amount !== t.originalAmount)
      .map(t => new ChangeOrderTaxLineRequest({
        taxTypeId: t.taxTypeId,
        amount: t.amount,
      }));

    const request = new CreateChangeOrderRequest({
      jobId: formData.jobId,
      idempotencyKey,
      soldBy: formData.soldBy ?? undefined,
      changeOrderDate: formData.changeOrderDate,
      currentJobTotal: formData.currentJobTotal,
      netChangeAmount: formData.netChangeAmount,
      newJobTotal: formData.newJobTotal,
      items: [...upsellItems, ...descopeItems],
      taxes,
    });
    return this.sdk.createChangeOrder(request);
  }
}
